<template>
  <v-combobox
    v-on="$listeners"
    v-bind="$attrs"
    :items="items"
    :loading="isLoading"
    :value="readonlyValue"
    :search-input.sync="search"
    hide-no-data
    hide-selected
    :item-text="itemText"
    :item-value="itemValue"
    :return-object="returnObject"
    @update:search-input="handleSearchUpdate"
    @input="inputHandler"
    no-filter
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-combobox>
</template>

<script>
import { JSONPath } from 'jsonpath-plus';

let abortController = null;

export default {
  props: {
    value: {
      default: null,
    },

    searchInput: {
      type: [String, Number],
      default: '',
    },

    url: {
      type: String,
      required: true,
    },

    arrayProperty: {
      type: String,
      required: true,
    },

    itemValue: {
      type: String,
      required: true,
    },

    itemText: {
      type: String,
      required: true,
    },

    returnObject: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      items: [],
      isLoading: false,
      model: null,
      search: null,
      searchTimeout: null,
    };
  },

  methods: {
    inputHandler(v) {
      const value = {};
      value[this.itemText] = v;
      // this.items = [];
      // console.log(JSONPath({ path: `$.${this.itemValue}`, json: v })[0] ?? v);
      console.log('input', JSONPath({ path: `$.${this.itemValue}`, json: value })[0] ?? value);
      // if (typeof v === 'object') console.log(v )
      console.log(v);
      this.$emit('input', JSONPath({ path: `$.${this.itemValue}`, json: value })[0] ?? value);
    },
    handleSearchUpdate(val) {
      // this.search = val;
      // this.$emit('update:search-input', val);
    },
  },

  watch: {
    value(val) {
      // this.search = val;
    },
    search(val) {
      abortController?.abort();

      // this.$emit('', val);

      this.loading = false;
      clearTimeout(this.searchTimeout);
      if (!val) {
        return;
      }
      this.searchTimeout = setTimeout(async () => {
        this.isLoading = true;

        const searchParams = {
          limit: 100,
        };
        searchParams[this.itemText] = val;

        abortController = new AbortController();
        const request = this.$http.post(this.url, searchParams, { signal: abortController.signal });

        const items = (await request)[this.arrayProperty];

        // this.items = items.sort();
        this.items = items
          .filter((e) => {
            return JSONPath({ path: `$.${this.itemValue}`, json: e })[0];
          })
          .sort((a, b) => {
            a = JSONPath({ path: `$.${this.itemValue}`, json: a })[0];
            b = JSONPath({ path: `$.${this.itemValue}`, json: b })[0];
            return a - b;
          });

        this.isLoading = false;
      }, 500);
    },
  },

  computed: {
    readonlyValue() {
      return this.value;
    },

    searchInputValue() {
      if (this.searchInput) {
        return this.searchInput;
      }
      if (this.value) {
        return JSONPath({ path: `$.${this.itemValue}`, json: this.value })[0] ?? this.value;
      }
      return '';
    },
  },
};
</script>
